import GetRequest from "csi/comm/GetRequest";
import session from "csi/session";
import { LOCATION_RIGHT_PANE, getLocationHash } from "csi/utility/routerUtility";
import { SLACK } from "csi/service/rightPaneService";

export function getAskSlackPermissionsUrl(): string {
	const url = new URL(location.toString());

	const params = session.getLocationParams();
	params[LOCATION_RIGHT_PANE] = SLACK;
	url.hash = getLocationHash(params);

	const askSlackPermissionsUrl = new GetRequest("Slack", "AskSlackPermissions")
		.addParameter("ClientURL", url.toString())
		.toRequest();
	return askSlackPermissionsUrl;
}
